// Third-party loaders that used to live as inline <script> blocks in index.html.
// Moved into a webpack entry so script-src can drop 'unsafe-inline' without
// maintaining per-environment sha256 hashes (KB-8721).
import Configuration from 'cdblEnvConfig'

const w = window
const d = document

// Intercom settings (must exist before the widget loads)
w.intercomSettings = {
  app_id: Configuration.intercom.appId
}

// Google tag (gtag.js) - the async <script src="https://www.googletagmanager.com/gtag/js"> stays in index.html
w.dataLayer = w.dataLayer || []
function gtag () {
  w.dataLayer.push(arguments)
}
gtag('js', new Date())
gtag('config', Configuration.googleAnalytics)

// Intercom loader (official snippet, unminified)
;(function () {
  const ic = w.Intercom
  if (typeof ic === 'function') {
    ic('reattach_activator')
    ic('update', w.intercomSettings)
  } else {
    const i = function () { i.c(arguments) }
    i.q = []
    i.c = function (args) { i.q.push(args) }
    w.Intercom = i
    const l = function () {
      const s = d.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = `https://widget.intercom.io/widget/${Configuration.intercom.appId}`
      const x = d.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
    }
    if (d.readyState === 'complete') {
      l()
    } else {
      w.addEventListener('load', l, false)
    }
  }
})()

// Sleekplan loader
w.$sleek = []
w.SLEEK_PRODUCT_ID = 897714772
;(function () {
  const s = d.createElement('script')
  s.src = 'https://client.sleekplan.com/sdk/e.js'
  s.async = true
  d.getElementsByTagName('head')[0].appendChild(s)
})()

// Service worker registration
if ('serviceWorker' in navigator) {
  w.addEventListener('load', () => {
    navigator.serviceWorker.register(`/service-worker.${APP_ENV.REVISION}.js`).then(registration => {
      console.log('SW registered: ', registration)
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError)
    })
  })
}
